import {CandidateLevelTest, CandidateLevelTestRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import React from "react";

export const CandidateLevelTestListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<CandidateLevelTest> = {
		title: "Pruebas de Nivel",
		onClick: "/app/admin/recruitment/level/test",
		headers: [
			{title: "Nombre"}
		],
		decorator: (bean: CandidateLevelTest) => (
			< >
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
					{bean.name}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(CandidateLevelTestRestControllerApiFactory);
			return ctrl.pageCandidateLevelTest(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};